import React, { useState, useEffect } from 'react';
import { Background, Form, Title, Button, CloseIcon } from './style';
import InputLabel from '../../../InputLabel';
import SelectLabel from '../../../SelectLabel';
import { HiTrash } from 'react-icons/hi';
import api from '../../../../services/api';
import { userId } from '../../../../services/TokenData';
import TextareaLabel from '../../../TextareaLabel';
import FileInput from '../../../FileInput';
import { format } from '../../../../services/DateFormatter';
import alert from '../../../../utils/alert.js';
export default function RegisterOcorrencia({ Show, setShow, NumProcesso, IdProcesso, Reload, setReload, Dados, sequencia, setSequencia }) {
    const [Descricao, setDescricao] = useState('');
    const [NovaSituacao, setNovaSituacao] = useState('');
    const [Assunto, setAssunto] = useState('');
    const [Destinatarios, setDestinatarios] = useState(null);
    const [IdDestinatarios, setIdDestinatarios] = useState(null);
    const [IdDestinatario, setIdDestinatario] = useState(0);
    const [QuantDias, setQuantDias] = useState(0);
    const [ShowFileInput, setShowFileInput] = useState(false);
    const [Anexo, setAnexo] = useState(null);
    const [RealodData, setRealodData] = useState(false);
    const [DataPrevista, setDataPrevista] = useState(format({ DataInicial: new Date(), Formato: 'YYYY-MM-DD' }));
    const dataMaximaParaAtribuicao = null;
    const [isChecked, setIsChecked] = useState(false);

    const handleOnChange = () => {
        setIsChecked(!isChecked);
    };

    useEffect(() => {
        async function Request() {
            api.get(`/user/destinatarios/${userId()}`).then((response) => {
                setDestinatarios(['Ninguém', ...response.data.usuarios.map((r) => r.nome)]);
                setIdDestinatarios([null, ...response.data.usuarios.map((r) => r.id)]);
            });
        }
        Request();
    }, []);

    async function HandleSubmit(e) {
        e.preventDefault();
        if (isChecked && IdDestinatario === 0) {
            alert(
                'Alert-popup',
                'Você marcou que deseja encaminhar a ocorrência, mas não selecionou nenhum destinatário. Por favor, selecione ao menos uma pessoa para continuar.',
                '6000',
                '',
                '',
                'top-end',
                'fit-content'
            );
            return;
        }

        const data = {
            num_processo: NumProcesso,
            id_processo: IdProcesso,
            descricao: Descricao,
            id_remetente: userId(),
            id_destinatario: isChecked ? IdDestinatario : userId(),
            data_prevista: DataPrevista || null,
            seq_ocorrencia: sequencia?.seq_ocorrencia,
        };

        try {
            const response = await api.post(`/ocorrencias`, { data });

            if (Anexo) {
                const formData = new FormData();
                formData.append('file', Anexo);
                formData.append('seq_ocorrencia', response?.data?.seq);
                formData.append('nivel_ocorrencia', response?.data?.nivel);
                formData.append('assunto_documento', Assunto);

                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                };

                await api.post(
                    `/anexos?processo=${data.id_processo}&seq_ocorrencia=${response?.data?.seq}&nivel_ocorrencia=${response?.data?.nivel}`,
                    formData,
                    config
                );
            }

            if (isChecked && IdDestinatario && IdDestinatario !== userId()) {
                try {
                    await api.post(`/user/mail_ocorrencia`, {
                        num_processo: NumProcesso,
                        id_processo: IdProcesso,
                        descricao: Descricao,
                        id_remetente: userId(),
                        id_destinatario: IdDestinatario,
                        data_prevista: DataPrevista || null,
                    });
                } catch (mailError) {
                    console.error('Erro ao salvar a ocorrência:', mailError);
                }
            }
            alert(
                'Sucesso-popup',
                `${sequencia?.seq_ocorrencia ? 'Subocorrência' : 'Ocorrência'} criada com sucesso!`,
                3000,
                '',
                '',
                'top-end',
                'fit-content'
            );

            Close();
            setReload(!Reload);
        } catch (error) {
            console.error('Erro ao salvar ocorrência:', error);
            alert(
                'Erro-popup',
                `Erro ao criar ${sequencia?.seq_ocorrencia ? 'subocorrência' : 'ocorrência'}!`,
                3000,
                '',
                '',
                'top-end',
                'fit-content'
            );
        }
    }

    async function Close() {
        setDescricao('');
        setNovaSituacao('');
        setIdDestinatario(0);
        setQuantDias(0);
        setAnexo(null);
        setShow(false);
        setSequencia(null);
        setIsChecked(false);
        setDataPrevista(format({ DataInicial: new Date(), Formato: 'YYYY-MM-DD' }));
    }

    return (
        <Background Show={Show}>
            <Form onSubmit={HandleSubmit}>
                <CloseIcon onClick={() => Close()} />
                {}
                <Title>
                    Nova {sequencia?.seq_ocorrencia ? 'Subocorrencia' : 'Ocorrencia'} - Processo {Dados?.numero}
                </Title>
                <TextareaLabel
                    value={Descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    label="Descrição"
                    id={'ocorrencia-descricao'}
                    required
                />
                <div className="encaminharOcorrencia">
                    <input type="checkbox" className="checkEncaminhar" checked={isChecked} onChange={handleOnChange} />
                    <label>Encaminhar Ocorrência?</label>
                </div>
                <SelectLabel
                    label="Encaminhar ocorrência?"
                    value={IdDestinatario}
                    onChange={(e) => setIdDestinatario(e.target.value)}
                    defaultValue="Selecione o usuário"
                    options={Destinatarios}
                    values={IdDestinatarios}
                    disabled={!isChecked}
                    required={isChecked}
                />
                <InputLabel
                    type="date"
                    value={DataPrevista}
                    onChange={(e) => setDataPrevista(e.target.value)}
                    label="Data Proposta para Finalização"
                    required
                    max={sequencia?.data_prevista || Dados?.data_prevista?.slice(0, 10)}
                />
                {Anexo && (
                    <span
                        style={{
                            color: 'black',
                            border: '1px solid black',
                            padding: '1%',
                            borderRadius: '3%',
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                    >
                        📎 Anexo: {Anexo.name}
                        <HiTrash style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setAnexo(null)} title="Remover anexo" />
                    </span>
                )}
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '10%' }}>
                    <Button type="button" onClick={() => setShowFileInput(true)}>
                        Anexar arquivo
                    </Button>
                    <Button type="submit" style={{ background: 'green' }}>
                        Salvar
                    </Button>
                </div>
                <FileInput
                    setShow={setShowFileInput}
                    Show={ShowFileInput}
                    NumProcesso={NumProcesso}
                    IdProcesso={IdProcesso}
                    setAnexo={setAnexo}
                    Origin={'Ocorrencia'}
                    setRealodData={setRealodData}
                    Assunto={Assunto}
                    setAssunto={setAssunto}
                />
            </Form>
        </Background>
    );
}
